import { PagedResult, Result, Media } from "../models/index";
import { ServiceBase } from './ServiceBase';

export class SearchIn {
    keywords: string;
    path: string;
    culture: string;

    constructor() {
        this.keywords = '';
        this.path = '';
    }

    public static fromInput(input: Partial<SearchIn>) {
        var result = new SearchIn();
        result = { ...result, ...input };
        return result;
    }
}

export class MediaService extends ServiceBase {

    public static async search(filters: SearchIn, pageSize: number, offset: number): Promise<Result<PagedResult<Media>>> {

        let searchDto = filters;

        let payload = { ...searchDto, pageSize, offset };

        var result = await this.requestJson<PagedResult<Media>>({
            url: `/api/Media/List`,
            method: "POST",
            data: payload
        });

        return result;
    }   
}
